import { IApplicationState } from '../../types/redux';

/**
 * Выбирает карточку поста
 */
export const selectPost = ({ post }: IApplicationState) => post;
